import { Divider, Stack, Theme, Typography } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';

interface AsideMenuDividersGroupNamesProps {
    menuItem: { id: string };
    t: TFunction;
    theme: Theme;
}

const AsideMenuDividersGroupNames: React.FC<AsideMenuDividersGroupNamesProps> = ({
    menuItem,
    t,
    theme,
}) => {
    return (
        <>
            {menuItem.id === 'menu_api' && (
                <Divider orientation="horizontal" sx={{ width: '100%' }} />
            )}
            {menuItem.id === 'menu_perps' && (
                <>
                    <Divider orientation="horizontal" sx={{ width: '100%' }} />
                    <Stack minHeight={'32px'} flexDirection={'row'} alignItems={'center'}>
                        <Typography
                            variant={'p12'}
                            color={theme.palette.primitives.woodsmoke[700]}
                            fontWeight={500}
                            pl={'16px'}
                        >
                            {t('hypertracker_sidebar.group_market_analytics')}
                        </Typography>
                    </Stack>
                </>
            )}
            {menuItem.id === 'menu_builders' && (
                <Divider orientation="horizontal" sx={{ width: '100%' }} />
            )}
            {menuItem.id === 'menu_favorites' && (
                <Stack minHeight={'32px'} flexDirection={'row'} alignItems={'center'}>
                    <Typography
                        variant={'p12'}
                        color={theme.palette.primitives.woodsmoke[700]}
                        fontWeight={500}
                        pl={'16px'}
                    >
                        {t('hypertracker_sidebar.group_tools')}
                    </Typography>
                </Stack>
            )}
        </>
    );
};

export default AsideMenuDividersGroupNames;
